import "@webcomponents/custom-elements";
import "@github/clipboard-copy-element";

import Teamshares from "@teamshares/design-system/rails-js";

import "whatwg-fetch";
import Dropzone from "dropzone";

import "trix";
import "@rails/actiontext";

import "./channels";

import "./includes/numberFormat";
import "./includes/taxFieldEntry";
import "./includes/termsModeling";
import "./includes/admin/leadBrokerUpdate";
import "./includes/admin/emails/sendEmails";
import "./includes/admin/emails/editRecipients";
import "./includes/admin/twilioCall";

import { datadogRum } from "@datadog/browser-rum";

import MicroModal from "micromodal";

// MicroModal 0.7 registers one instance per modal id and keeps it for the page's lifetime. Our
// js.erb responses re-render a modal's markup into its base element before each show, which leaves
// that registration pointing at the detached previous markup, so the second open shows nothing
// until the page reloads. A modal element MicroModal has registered carries data-micromodal-id;
// a freshly rendered one does not, so drop the stale registration before showing it.
const showMicroModal = MicroModal.show;
MicroModal.show = (modal, config) => {
  const element = typeof modal === "string" ? document.getElementById(modal) : modal;
  if (element && !element.hasAttribute("data-micromodal-id")) MicroModal.removeModal(modal);
  return showMicroModal(modal, config);
};
window.MicroModal = MicroModal;

Teamshares.start({ disableTurboSessionDrive: true });

Dropzone.autoDiscover = false;

if (window._ddSessionReplayEnabled === "true") {
  datadogRum.init({
    applicationId: window._ddApplicationId,
    clientToken: window._ddClientToken,
    site: window._ddSite,
    service: window._ddService,
    env: window._ddEnvironment,
    version: Teamshares.deployed_app_sha,
    sessionSampleRate: parseInt(window._ddSessionSampleRate),
    premiumSampleRate: parseInt(window._ddPremiumSampleRate),
    trackUserInteractions: !!window._ddTrackUserInteractions,
    defaultPrivacyLevel: window._ddPrivacyLevel,
  });

  datadogRum.startSessionReplayRecording();
}

// Remove unused Trix toolbar buttons via config rather than CSS so keyboard
// shortcuts bound to hidden buttons are also inactive.
document.addEventListener("trix-initialize", ({ target }) => {
  const toolbar = target.toolbarElement;
  [
    ".trix-button--icon-heading-1",
    ".trix-button--icon-code",
    ".trix-button--icon-decrease-nesting-level",
    ".trix-button--icon-increase-nesting-level",
    ".trix-button-group--file-tools",
    ".trix-button-group--history-tools",
  ].forEach((selector) => toolbar.querySelector(selector)?.remove());
});

// This handles the case of missing turbo-frame targets by just reloading the page
// (which turbo did automatically prior to 7.3.0)
document.addEventListener("turbo:frame-missing", (event) => {
  const { detail: { response, visit } } = event;
  console.warn("Missing turbo-frame target:", event.target);
  event.preventDefault();
  visit(response.url);
});
